// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__22TqA","footer":"ReportModalFilter_footer__2VXtL"};